import React from 'react';
import { Box } from '@mui/material';

/**
 * Separator Component
 * 
 * A horizontal line separator with optional pink accent in the center
 * Used to separate sections in the Properties Panel
 */
const Separator = ({ withAccent = false }) => {
  return (
    <Box
      sx={{
        height: '1px',
        backgroundColor: '#E0E0E0',
        marginY: '16px',
        position: 'relative',
      }}
    >
      {withAccent && (
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: '20px',
            height: '2px',
            backgroundColor: '#EC4899',
          }}
        />
      )}
    </Box>
  );
};

export default Separator;


